var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.4 57C113.4 88.1483 88.1483 113.4 57 113.4C25.8517 113.4 0.600006 88.1483 0.600006 57C0.600006 25.8517 25.8517 0.600006 57 0.600006C88.1483 0.600006 113.4 25.8517 113.4 57Z",
    fill: "#1F76FF",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0474 73.5345C72.0474 75.0587 59.7057 76.2953 44.4819 76.2953C29.2581 76.2953 16.9164 75.0587 16.9164 73.5345C16.9164 72.0103 29.2581 70.7737 44.4819 70.7737C59.7057 70.7737 72.0474 72.0103 72.0474 73.5345Z",
    fill: "#1F76FF",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5221 71.5846H19.4403C18.662 71.5846 18.0303 70.9529 18.0303 70.1746V17.9764C18.0303 17.1981 18.662 16.5664 19.4403 16.5664H69.5221C70.3018 16.5664 70.9321 17.1981 70.9321 17.9764V70.1746C70.9321 70.9529 70.3018 71.5846 69.5221 71.5846Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5221 71.5846H19.4403C18.662 71.5846 18.0303 70.9529 18.0303 70.1746V17.9764C18.0303 17.1981 18.662 16.5664 19.4403 16.5664H69.5221C70.3018 16.5664 70.9321 17.1981 70.9321 17.9764V70.1746C70.9321 70.9529 70.3018 71.5846 69.5221 71.5846Z",
    stroke: "#1F76FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1743 58.8891H25.7895C25.0112 58.8891 24.3795 58.2574 24.3795 57.4791V24.3258C24.3795 23.5475 25.0112 22.9158 25.7895 22.9158H63.1743C63.9526 22.9158 64.5843 23.5475 64.5843 24.3258V57.4791C64.5843 58.2574 63.9526 58.8891 63.1743 58.8891Z",
    fill: "#1F76FF",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1743 58.8891H25.7895C25.0112 58.8891 24.3795 58.2574 24.3795 57.4791V24.3258C24.3795 23.5475 25.0112 22.9158 25.7895 22.9158H63.1743C63.9526 22.9158 64.5843 23.5475 64.5843 24.3258V57.4791C64.5843 58.2574 63.9526 58.8891 63.1743 58.8891Z",
    stroke: "#1F76FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6008 58.8891C56.6338 53.2505 50.6709 49.1333 44.4824 49.1333C38.294 49.1333 32.3297 53.2505 30.3627 58.8891H58.6008Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6008 58.8891C56.6338 53.2505 50.6709 49.1333 44.4824 49.1333C38.294 49.1333 32.3297 53.2505 30.3627 58.8891H58.6008Z",
    stroke: "#4550E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3246 39.0473C51.3246 42.8275 48.2621 45.89 44.4819 45.89C40.7031 45.89 37.6392 42.8275 37.6392 39.0473V35.6267C37.6392 31.8479 40.7031 28.7825 44.4819 28.7825C48.2621 28.7825 51.3246 31.8479 51.3246 35.6267V39.0473Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3246 39.0473C51.3246 42.8275 48.2621 45.89 44.4819 45.89C40.7031 45.89 37.6392 42.8275 37.6392 39.0473V35.6267C37.6392 31.8479 40.7031 28.7825 44.4819 28.7825C48.2621 28.7825 51.3246 31.8479 51.3246 35.6267V39.0473Z",
    stroke: "#4550E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3246 39.0473C51.3246 42.8275 48.2621 45.89 44.4819 45.89C40.7031 45.89 37.6392 42.8275 37.6392 39.0473V35.6267C37.6392 31.8479 40.7031 28.7825 44.4819 28.7825C48.2621 28.7825 51.3246 31.8479 51.3246 35.6267V39.0473Z",
    stroke: "#1F76FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6008 58.8891C56.6338 53.2505 50.6709 49.1333 44.4824 49.1333C38.294 49.1333 32.3297 53.2505 30.3627 58.8891H58.6008Z",
    stroke: "#1F76FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8838 95.0005C89.8838 96.3442 84.076 97.4327 76.9118 97.4327C69.7475 97.4327 63.9398 96.3442 63.9398 95.0005C63.9398 93.6582 69.7475 92.5682 76.9118 92.5682C84.076 92.5682 89.8838 93.6582 89.8838 95.0005Z",
    fill: "#1F76FF",
    fillOpacity: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0838 64.3757C97.0838 62.9319 95.9135 61.7602 94.4696 61.7602H84.0074C83.2855 61.7602 82.6989 61.175 82.6989 60.4517V49.9909C82.6989 48.5471 81.5286 47.3754 80.0848 47.3754H73.5466C72.1014 47.3754 70.9311 48.5471 70.9311 49.9909V60.4517C70.9311 61.175 70.3459 61.7602 69.6226 61.7602H59.1618C57.718 61.7602 56.5463 62.9319 56.5463 64.3757V70.9139C56.5463 72.3591 57.718 73.5294 59.1618 73.5294H69.6226C70.3459 73.5294 70.9311 74.1146 70.9311 74.8365V85.2987C70.9311 86.7426 72.1014 87.9129 73.5466 87.9129H80.0848C81.5286 87.9129 82.6989 86.7426 82.6989 85.2987V74.8365C82.6989 74.1146 83.2855 73.5294 84.0074 73.5294H94.4696C95.9135 73.5294 97.0838 72.3591 97.0838 70.9139V64.3757Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0838 64.3757C97.0838 62.9319 95.9135 61.7602 94.4696 61.7602H84.0074C83.2855 61.7602 82.6989 61.175 82.6989 60.4517V49.9909C82.6989 48.5471 81.5286 47.3754 80.0848 47.3754H73.5466C72.1014 47.3754 70.9311 48.5471 70.9311 49.9909V60.4517C70.9311 61.175 70.3459 61.7602 69.6226 61.7602H59.1618C57.718 61.7602 56.5463 62.9319 56.5463 64.3757V70.9139C56.5463 72.3591 57.718 73.5294 59.1618 73.5294H69.6226C70.3459 73.5294 70.9311 74.1146 70.9311 74.8365V85.2987C70.9311 86.7426 72.1014 87.9129 73.5466 87.9129H80.0848C81.5286 87.9129 82.6989 86.7426 82.6989 85.2987V74.8365C82.6989 74.1146 83.2855 73.5294 84.0074 73.5294H94.4696C95.9135 73.5294 97.0838 72.3591 97.0838 70.9139V64.3757Z",
    stroke: "#1F76FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile-image.a8646cac69f9478642d46165b0e2e326.svg";
export { ForwardRef as ReactComponent };